<template>
  <div>

    <div class="invisible" v-if="handleItem">
      <!--    <div style="z-index: 34454; position: fixed; top: 200px; left: 20px; background-color: #BBB" v-if="handleItem">-->
<!--      <div>DEBUG item TYPE = {{ handleItem.type }}</div>-->

      <div v-if="handleItem.type === 'drinkOrder'">
        <div>DrinkItemDetail</div>
        <DrinkItemDetail
          @wasAdded="finish"
          :itemId="handleItem.id"
          :addDirectly="true"
        ></DrinkItemDetail>
      </div>

      <div v-if="handleItem.type === 'foodOrder'">
        <div>DrinkItemDetail</div>
        <ItemDetail
          @wasAdded="finish"
          :itemId="handleItem.id"
          :addDirectly="true"
        ></ItemDetail>
      </div>

    </div>

  </div>
</template>

<script>
import DrinkItemDetail from "@/views/DrinkItemDetail.vue";
import ItemDetail from "@/views/ItemDetail.vue";

export default {
  name: "AddDirectlyHandler",
  components: {ItemDetail, DrinkItemDetail},
  computed: {
    handleItem() {
      let handle = this.$store.getters.itemForAddDirectly;
      // if (handle?.id) {
      // }
      return handle;
    },
  },

  methods: {
    finish() {
      this.$store.commit('itemForAddDirectly', null);
    }
  },

}
</script>

<style scoped>

</style>
